import {Injectable} from '@angular/core';
import {APIService} from "./api.service";
import {ITestEmails} from "../interfaces/ITestEmails";
import {IEmailTemplateType} from "../interfaces/IEmailTemplateType";

@Injectable({
  providedIn: 'root'
})
export class EmailTestingService {

  constructor(private apiService: APIService) {

  }

  public sendTestEmails(testEmailsRequest: ITestEmails){
    return this.apiService.MakePostRequest<any>('admin-user/send-test-emails', testEmailsRequest);
  }

  public getEmailTemplateTypes() {
    return this.apiService.MakeGetRequest<IEmailTemplateType[]>('sendgrid/email-template-types');
  }
}
